import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import Skills from './components/Skills';
import Resume from './components/Resume';
import ResumeLock from './components/ResumeLock';
import ProtectedRoute from './components/ProtectedRoute';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={
            <>
              <Header />
              <Hero />
              <Skills />
              <Footer />
            </>
          } />
          <Route path="/resume" element={
            <ProtectedRoute>
              <Resume />
            </ProtectedRoute>
          } />
          <Route path="/resume-access" element={<ResumeLock />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
